<template>
  <div id="footer">
    <p class="font-weight-bolder">Columbus Metropolitan Library &copy; {{ currentYear }}</p>
  </div>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style lang="scss" scoped>
#footer{
  background-color: #999999;
  color: #fff;
  text-align: center;
  padding: 10px;
  font-family: "Montserrat", sans-serif !important;
}
</style>
